export default {
    ID: "2",
    SLUG: "bartone",
    NAME: "Bartone",
    PRIMARY: "#000000",
    SECONDARY: "#141414",
    API: "https://api.bartone.io",
    LOGO: "/bartone/logo.png",
    APP_ICON: "/assets/bartone/bartone.svg",
    APP_LOGO: "/assets/bartone/bartone.svg",
    APP_FAVICON: "/assets/bartone/favicon.ico",
    APP_NAME: "Bartone",
  };